import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { CustomerHubRedirect } from './-ui/customer-hub-redirect'
import type { CustomerHubTab } from './companies/-ui/customer-company-hub'

// Legacy-табы «Моей компании» → табы хаба; comments в хабе нет — дефолтный таб.
const LEGACY_TABS = ['docs', 'invoices', 'requisites', 'comments'] as const

const SearchSchema = z.object({
  tab: z.enum(LEGACY_TABS).optional().catch(undefined),
})

const TAB_MAP: Partial<Record<(typeof LEGACY_TABS)[number], CustomerHubTab>> = {
  docs: 'docs',
  invoices: 'invoices',
  requisites: 'requisites',
}

// Legacy deep-link: «Моя компания» заказчика — это его хаб /companies/$company.
export const Route = createFileRoute('/_app/my-company')({
  validateSearch: (search) => SearchSchema.parse(search),
  beforeLoad: ({ context }) => {
    if (context.session?.kind === 'employee') throw redirect({ to: '/companies' })
  },
  head: () => ({ meta: [{ title: 'Моя компания · STIT Deal' }] }),
  component: MyCompanyRedirect,
})

function MyCompanyRedirect() {
  const { tab } = Route.useSearch()
  const mapped = tab ? TAB_MAP[tab] : undefined
  return <CustomerHubRedirect {...(mapped ? { tab: mapped } : {})} />
}
